const { filterType } = require('./filterparamtype');
const { booleanType } = require('./booleanparamtype');

function urlMatcherConfig($urlMatcherFactoryProvider) {
    $urlMatcherFactoryProvider.caseInsensitive(true);
    $urlMatcherFactoryProvider.strictMode(false);

    $urlMatcherFactoryProvider.type('filter', filterType);
    $urlMatcherFactoryProvider.type('boolean', booleanType);
}

module.exports = { urlMatcherConfig };



// WEBPACK FOOTER //
// ./src/configuration/urlmatcher.js